const {
  fetchJsonApi,
  fetchAuthorizedJsonApi,
  fetchAuthorizedUploadJsonApi,
} = require('./abstract');
const { getApiLanguage } = require('./language');
const { apiUrls } = require('./apiUrls');

const fetchUserData = (token) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'GET',
    endpoint: 'users/me',
    expectedStatus: 200,
    description: 'Fetching logged in user data',
  });

function fetchOtherUserData(id) {
  return fetchJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    method: 'GET',
    endpoint: `users/${id}`,
    body: { uid: id },
    expectedStatus: 200,
    description: `Fetching user with id: ${id}`,
  });
}

function createUser(token, userInfo = {}) {
  return fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'POST',
    body: userInfo,
    endpoint: 'users',
    expectedStatus: 200,
    description: 'Creating new radar user',
  });
}

function updateUserData(token, userData) {
  return fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    body: userData,
    endpoint: 'users/me',
    expectedStatus: 200,
    description: 'Updating user data',
  });
}

function syncUserData(token) {
  return fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    endpoint: 'users/me/sync',
    expectedStatus: 200,
    description: 'Syncing user data',
  });
}

function updateUserAvatar(token, avatar) {
  return fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    body: { avatar },
    endpoint: 'users/me/avatar',
    expectedStatus: 200,
    description: 'Updating user avatar',
  });
}

function uploadUserAvatar(token, avatar) {
  return fetchAuthorizedUploadJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'POST',
    files: { avatar },
    endpoint: 'users/me/custom-avatar',
    expectedStatus: 200,
    description: 'Uploading and updating user avatar',
  });
}

function fetchRadarConfig() {
  return fetchJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    method: 'GET',
    endpoint: 'config',
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching radar config',
  });
}

function deleteRadarUser(token) {
  return fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'DELETE',
    endpoint: 'users/me',
    expectedStatus: 204,
    description: 'Deleting Radar user',
  });
}

module.exports = {
  fetchUserData,
  fetchOtherUserData,
  createUser,
  updateUserAvatar,
  uploadUserAvatar,
  updateUserData,
  fetchRadarConfig,
  deleteRadarUser,
  syncUserData,
};
